import { render } from "./QuestionSectionIndexComponent.vue?vue&type=template&id=05ce2fd4"
import script from "./QuestionSectionIndexComponent.vue?vue&type=script&lang=js"
export * from "./QuestionSectionIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__